"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateCondition = void 0;
const lodash_1 = __importDefault(require("lodash"));
const evaluateExpression_1 = require("./evaluateExpression");
function isEmpty(value) {
    if (value == null)
        return true;
    return value.toString().trim() == '';
}
function isLike(value, test) {
    if (!value)
        return false;
    if (!test)
        return false;
    const regex = new RegExp(`^${lodash_1.default.escapeRegExp(test).replace(/%/g, '.*')}$`, 'i');
    const res = !!value.toString().match(regex);
    return res;
}
function evaluateCondition(condition, values) {
    switch (condition.conditionType) {
        case 'binary':
            const left = (0, evaluateExpression_1.evaluateExpression)(condition.left, values);
            const right = (0, evaluateExpression_1.evaluateExpression)(condition.right, values);
            switch (condition.operator) {
                case '=':
                    return left == right;
                case '!=':
                case '<>':
                    return left != right;
                case '<=':
                    return left <= right;
                case '>=':
                    return left >= right;
                case '<':
                    return left < right;
                case '>':
                    return left > right;
            }
            break;
        case 'isNull':
            return (0, evaluateExpression_1.evaluateExpression)(condition.expr, values) == null;
        case 'isNotNull':
            return (0, evaluateExpression_1.evaluateExpression)(condition.expr, values) != null;
        case 'isEmpty':
            return isEmpty((0, evaluateExpression_1.evaluateExpression)(condition.expr, values));
        case 'isNotEmpty':
            return !isEmpty((0, evaluateExpression_1.evaluateExpression)(condition.expr, values));
        case 'and':
            return condition.conditions.every(cond => evaluateCondition(cond, values));
        case 'or':
            return condition.conditions.some(cond => evaluateCondition(cond, values));
        case 'like':
            return isLike((0, evaluateExpression_1.evaluateExpression)(condition.left, values), (0, evaluateExpression_1.evaluateExpression)(condition.right, values));
            break;
        case 'notLike':
            return !isLike((0, evaluateExpression_1.evaluateExpression)(condition.left, values), (0, evaluateExpression_1.evaluateExpression)(condition.right, values));
        case 'not':
            return !evaluateCondition(condition.condition, values);
    }
}
exports.evaluateCondition = evaluateCondition;
